/**
 * Controller: TemplatesShowAccountsModal
 */
angular.module('acme.view.application.templates.showCouponsModal.controllers', [])
.controller('TemplatesShowCouponsModalController', [ '$scope', '$uibModalInstance', 'CouponCategoryListData', function ($scope, $uibModalInstance, CouponCategoryListData) {

    $scope.errors = [];

    $scope.model = [];

    $scope.init = function() {
      if (CouponCategoryListData.data && CouponCategoryListData.data.success) {
        $scope.handlers.success.init(CouponCategoryListData);
      }else{
        $scope.handlers.error.init(CouponCategoryListData);
      }
    };

    $scope.hasData = function() {
      return ($scope.model instanceof Array && $scope.model.length > 0);
    };

    $scope.handlers = {
      success: {
        init: function(response) {
          $scope.model = response.data.payload.list;
        }
      },
      error: {
        init: function (response) {
          $scope.errors = [
            {
              message: response.data.error
            }
          ];
        }
      }
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);